import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Events } from "ionic-angular";
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

import * as moment from "moment";

import { Api } from "../api";
import { User } from '../../models/user.model';

@Injectable()
export class AuthProvider extends Api {

  user: User;

  constructor(public http: HttpClient, public events: Events) {
    super(http);
  }

  login(data: any): Observable<{}> {
    let headersConfig = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http
      .post(`${this.url}/auth/login`, data, {
        headers: headersConfig
      })
      .map(response => this.createToken(response))
      .do(() => this.events.publish('auth:logged'))
      .catch(this.handleError);
  }

  profile(): Observable<User> {
    return this.http
      .get(`${this.url}/auth/profile`)
      .map(response => {
        this.user = new User(response);
        return this.user;
      })
      .catch(this.handleError);
  }

  acceptTosAndPrivacy(data: any): Observable<any> {
    let headersConfig = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http
      .patch(`${this.url}/auth/accept-tos-and-privacy`, data, {
        headers: headersConfig
      })
      .catch(this.handleError);
  }

  update(data: any): Observable<User> {
    let headersConfig = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http
      .patch(`${this.url}/auth/update`, data, {
        headers: headersConfig
      })
      .map(response => {
        this.user = new User(response);
        return this.user;
      })
      .catch(this.handleError);
  }

  updateLanguage(data: any): Observable<any> {
    let headersConfig = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http
      .patch(`${this.url}/auth/update-language`, data, {
        headers: headersConfig
      })
      .catch(this.handleError);
  }

  updatePushID(data: any): Observable<any> {
    let headersConfig = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http
      .patch(`${this.url}/auth/update-push-id`, data, {
        headers: headersConfig
      })
      .catch(this.handleError);
  }

  uploadAvatar(data: any): Observable<any> {
    let headersConfig = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http
      .post(`${this.url}/auth/avatar`, data, {
        headers: headersConfig
      })
      .catch(this.handleError);
  }

  register(data: any): Observable<Object> {
    let headersConfig = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http
      .post(`${this.url}/auth/register`, data, {
        headers: headersConfig
      })
      .catch(this.handleError);
  }

  forgottenPassword(data: any): Observable<Object> {
    let headersConfig = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http
      .post(`${this.url}/auth/forgotten-password`, data, {
        headers: headersConfig
      })
      .catch(this.handleError);
  }

  resetPassword(token: string, data: any): Observable<Object> {
    let headersConfig = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http
      .post(`${this.url}/auth/reset-password/${token}`, data, {
        headers: headersConfig
      })
      .catch(this.handleError);
  }

  private createToken(data: any) {
    localStorage.setItem('token', data.token);
    localStorage.setItem('expires_at', data.expires_at);
  }

  private deleteToken() {
    localStorage.removeItem('token');
    localStorage.removeItem('expires_at');
  }

  logout() {
    this.deleteToken();
    this.user = null;
  }

  public isLoggedIn() {
    return this.checkExpiration();
  }

  public isLoggedOut() {
    return !this.isLoggedIn();
  }

  public getToken() {
    return localStorage.getItem('token');
  }

  checkExpiration() {
    if (localStorage.getItem("expires_at")) {
      let expiration:number = parseInt(localStorage.getItem("expires_at"));
      if (moment().isBefore(moment.unix(expiration))) {
        return true;
      } else {
        this.deleteToken();
        return false;
      }
    } else {
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts